export default {
  common: {
    name: 'Name',
    date: 'Date',
    dateOfBirth: 'Date of Birth',
    facilityName: 'Preschool Name',
    schoolYear: '{year} SY',
    placeholderPreschool: 'Sample Preschool',
  },
  months: {
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sept: 'Sept',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
  },
  growthRecord: {
    title: 'Growth Record',
    height: 'Height',
    weight: 'Weight',
    kaupIndex: 'Kaup Index',
    median: 'Median: {value}{unit}',
    chartTitle: '{year} School Year Growth Record',
    percentileRange: 'Percentile range 3% ~ 97%',
    chartMonth: 'Month',
    chartPercentile3: 'Percentile 3%',
    chartPercentile97: 'Percentile 97%',
    monthLabel: '{month}',
  },
  childDevelopment: {
    domain: 'Domain',
    item: 'Item',
    previousYear: 'Previous SY',
    schoolYear: '{year} SY',
    rangeLabel: 'Apr {startYear} - Mar {endYear}',
    rangeLabelWithMonth: 'Apr {startYear} - {endMonth} {endYear}',
  },
  childDevelopmentAnalytics: {
    title: 'Development Analytics',
    exportDate: 'Export Date:',
    analysisPeriod: 'Analysis Period:',
    unitMonths: '(Unit: months)',
  },
  workSchedule: {
    dailyTitle: 'Daily Staff Schedule',
    monthlyTitle: 'Monthly Staff Schedule',
    staffName: 'Staff Name',
    plannedRequiredQualified: 'Planned: Required Qualified Staff',
    plannedAssignedQualified: 'Planned: Assigned Qualified Staff',
    actualRequiredQualified: 'Actual: Required Qualified Staff',
    actualAssignedQualified: 'Actual: Assigned Qualified Staff',
    surplusPlanned: 'Surplus/Shortage - Planned',
    surplusActual: 'Surplus/Shortage - Actual',
    dateFull: '{day}-{month}-{year}',
    dateYearMonth: '{month}-{year}',
  },
  guidancePlan: {
    schoolYearSuffix: ' SY',
  },
};
